import "../sass/style.scss";
import CurvedText from "./CurvedText.svelte";
import Wobble from "./Wobble.svelte";

new CurvedText({ target: document.querySelector(".circle") });
new Wobble({ target: document.querySelector(".wobble") });
